<template>
    <div class="HeaderNav"
         v-if="navigation"
    >
        <v-tooltip color="black" left open-delay="1000">
            <template v-slot:activator="{on, attrs}">
                <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        small
                        to="/dashboard"
                >
                    <v-icon small color="white">fas fa-home</v-icon>
                </v-btn>
            </template>
            <span>Dashboard</span>
        </v-tooltip>

        <v-tooltip v-for="(item, index) in navigation"
                   :key="index" color="black"
                   left
                   open-delay="1000"
        >
            <template v-slot:activator="{on, attrs}">
                <v-btn v-if="item && showNavSlot(user.role, item.slug)"
                       v-bind="attrs"
                       v-on="on"
                       icon
                       small
                       :to="'/page/' + item.slug"
                >
                    <v-icon small color="white">{{ item.icon }}</v-icon>
                </v-btn>
            </template>
            <span>{{ item.tooltip }}</span>
        </v-tooltip>

        <AccountSettings></AccountSettings>

        <v-tooltip color="black" left open-delay="1000">
            <template v-slot:activator="{on, attrs}">
                <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        small
                        @click.once="signOut"
                >
                    <v-icon small color="white">fas fa-lock</v-icon>
                </v-btn>
            </template>
            <span>Sign Out</span>
        </v-tooltip>
    </div>
</template>

<script>
import axios from 'axios';
import { mapMutations, mapActions, mapState } from 'vuex';
import store from '@/store/store';
import AccountSettings from '@/components/AccountSettings';

export default {
    name: 'PageHeader',
    components: { AccountSettings },
    computed: {
        ...mapState('auth', ['user']),

        navItems: {
            get() {
                return store.state.settings.settings.settingNavigation;
            },

            set() {
                this.setNavItems();
            }
        }
    },

    data() {
        return {
            allNavItems: [],
            navigation: false
        };
    },

    mounted() {
        this.getAllNavItems();
    },

    methods: {
        ...mapMutations({
            setSidebarMounted: 'sidebar/setSidebarMounted'
        }),

        ...mapActions({
            sendSignOut: 'auth/signOut',
            refreshSettings: 'settings/getAllSettings'
        }),

        getAllNavItems() {
            return new Promise((resolve) => {
                axios.get('/api/navigation-link/index')
                    .then(response => {
                        this.allNavItems = response.data.data.navigationLinks.links;
                        this.setNavItems();
                        resolve();
                    })
                    .catch(error => {
                        console.error(error);
                        resolve();
                    });
            });
        },

        signOut() {
            this.setSidebarMounted(false);
            this.sendSignOut();
        },

        showNavSlot(role, page) {
            if (role !== 'builder') {
                return true;
            }

            if (role === 'builder' && page === 'dashboard') {
                return true;
            }

            return false;
        },

        setNavItems() {
            let newNavItems = [];

            Object.entries(this.navItems).forEach(entry => {
                // eslint-disable-next-line no-unused-vars
                const [key, value] = entry;
                const link = this.allNavItems.find(i => i.id === value.navItem);

                newNavItems.push({
                    'tooltip': link.tooltip,
                    'icon': link.icon,
                    'slug': link.page.slug
                });
            });

            this.navigation = newNavItems;
        }
    }
};
</script>
<style lang="scss">
.HeaderNav {
    margin-left: auto;

    a {
        margin-right: 8px !important;
    }
}
</style>
